import { Box, IconButton, ModBox, Spacer } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { useStores } from '../../data/store'
import { isOsMobile } from '../../util/util'
import { DownloadInfo } from '../DownloadInfo'
import { FilterComp } from './FilterComp'
import { SearchComp } from './SearchComp'
import { styles } from './styles'

interface RightContainerInterface {
  leftComp?: string
  rightComp?: string
  filterData?: any
  shouldShowDownloadButtonTab?: boolean
  index?: number
}

const getComponentName = (compName: string, filterData?: any) => {
  switch (compName) {
    case 'search':
      return <SearchComp />
    case 'filter':
      return <FilterComp filterData={filterData} />

    default:
      return
  }
}

export const RightContainer = ({
  leftComp = '',
  rightComp,
  filterData,
  shouldShowDownloadButtonTab,
  index,
}: RightContainerInterface) => {
  const [infoPos, setInfoPos] = useState(-1)

  const navigation = useNavigation()
  const { toastMessage, toastResetMessage } = useStores((store) => ({
    toastMessage: store?.reports?.getMessage(),
    toastResetMessage: store?.reports?.resetMessage,
  }))
  const showDownloadInfo = toastMessage?.length > 0

  useEffect(() => {
    if (toastMessage?.length > 0) {
      setTimeout(() => {
        toastResetMessage()
      }, 5000)
    }
  }, [toastMessage, toastResetMessage])

  const onLayout = (evt: any) => {
    !isOsMobile() && setInfoPos(evt?.nativeEvent?.layout?.left)
  }
  return (
    <>
      {shouldShowDownloadButtonTab && (
        <DownloadInfo infoPos={infoPos} hide={!showDownloadInfo} onDismiss={toastResetMessage} message={toastMessage} />
      )}
      <ModBox {...styles.rightContainer}>
        {shouldShowDownloadButtonTab && (
          <Box onLayout={onLayout}>
            {showDownloadInfo && (
              <Box position={'absolute'} top={0} right={0} bg={'ERROR'} borderRadius={4} w={8} h={8} />
            )}
            <IconButton
              id={'DOWNLOAD'}
              size={22}
              color="PRIMARY"
              testID="download"
              onPress={() => navigation?.navigate(index === 1 ? 'txns-download' : 'settlements-download')}
            />
          </Box>
        )}
        <Spacer size={12} direction="horizontal" />
        {getComponentName(leftComp, filterData)}
        {rightComp && (
          <>
            <Spacer size={22} direction="horizontal" />
            {getComponentName(rightComp, filterData)}
          </>
        )}
      </ModBox>
    </>
  )
}
